import React, { useContext, useState } from 'react';

interface IAnimation {
  id: string;
  status: 'DONE' | 'IN_PROGRESS';
}

interface IContext {
  animations: IAnimation[];
  addAnimation: (animation: IAnimation) => void;
  setAnimationStatus: (animationId: string, status: 'DONE' | 'IN_PROGRESS') => void;
}

const AnimationsContext = React.createContext<Partial<IContext>>({});

export const AnimationsProvider = ({ ...props }) => {
  const [animations, setAnimations] = useState<IAnimation[] | undefined>();

  const addAnimation = (animation: IAnimation) => {
    animations ? setAnimations([...animations, animation]) : setAnimations([animation]);
  };

  const setAnimationStatus = (animationId: string, status: 'DONE' | 'IN_PROGRESS') => {
    const animation = animations && animations.find((a) => a.id === animationId);

    if (!animation) {
      return;
    }

    const otherAnimations = animations?.filter((a) => a.id !== animationId);

    const newAnimation = {
      ...animation,
      status,
    };

    otherAnimations?.length ? setAnimations([...otherAnimations, newAnimation]) : setAnimations([newAnimation]);
  };

  return (
    <AnimationsContext.Provider
      value={{
        animations,
        addAnimation,
        setAnimationStatus,
      }}
    >
      {props.children}
    </AnimationsContext.Provider>
  );
};

export const useAnimations = () => {
  const context = useContext(AnimationsContext);

  if (context === null) {
    throw new Error("'useAnimations' must be used inside 'AnimationsProvider'");
  }

  return context;
};

export default AnimationsProvider;
